export default __webpack_public_path__ + "static/media/20191109_000556.476a81f5.jpg";